<template>
    <a-row  v-for="(record, index) in myService">
        <div v-for="(serviceList, index) in record.service">
            <a-typography-title :level="5">CONTRATO {{ TitleServiceCut(serviceList.contrato)[0] }} </a-typography-title>
            <a-col v-for="(service, index) in serviceList.service">
                <CardServices 
                    :my_service="service" 
                    :layout_speed_vertical="true"
                    :layout_info_vertical="true"
                />
            </a-col>
            
        </div>
    </a-row>
</template>
<script>
import { agruparServicios, TitleServiceCut } from '@/plugins/odoo_services'
import CardServices from '@/components/Cards/CardServices.vue';
export default {
    components: {
        CardServices
    },
    data() {
        return {
            myService: []
        }
    },
    async mounted() {
        this.myService = await agruparServicios();
    },
    methods: {
        TitleServiceCut
    }
}
</script>